module.exports = __webpack_public_path__ + "img/3s.27fedf2b.png";